/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ClearanceCaseUpdateDocumentsResult {
  Error = 0,
  Success = 1,
  InvalidUser = 2,
  InvalidStatus = 3,
  CaseNotFound = 4,
}
